import { render, staticRenderFns } from "./LkDialog.vue?vue&type=template&id=4e890cad&scoped=true&"
import script from "./LkDialog.vue?vue&type=script&lang=js&"
export * from "./LkDialog.vue?vue&type=script&lang=js&"
import style0 from "./LkDialog.vue?vue&type=style&index=0&id=4e890cad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e890cad",
  null
  
)

export default component.exports